import { create, persist } from '@/libs';

const COOKIE_NAME = 'exato-cpf-store';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 dias

const writeCpfCookie = (cpf: string | null) => {
  if (typeof document === 'undefined') return;

  if (!cpf) {
    document.cookie = `${COOKIE_NAME}=; path=/; max-age=0`;
    return;
  }

  const cookieValue = encodeURIComponent(
    JSON.stringify({
      state: {
        cpf,
      },
    }),
  );

  document.cookie = `${COOKIE_NAME}=${cookieValue}; path=/; max-age=${COOKIE_MAX_AGE}; sameSite=lax`;
};

type ExatoCpfStore = {
  cpf: string | null;
  setCpf: (cpf: string) => void;
  clearCpf: () => void;
};

export const useExatoCpfStore = create<ExatoCpfStore>()(
  persist(
    (set, get) => ({
      cpf: null,

      setCpf: (cpf) => {
        const current = get().cpf;

        if (current !== cpf) {
          set({ cpf });
          writeCpfCookie(cpf);
        }
      },

      clearCpf: () => {
        set({ cpf: null });
        writeCpfCookie(null);
      },
    }),
    {
      name: 'exato-cpf-store',
    },
  ),
);
